module.exports = __webpack_public_path__ + "static/media/header.1aeb022b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/biocodex-um/header.png
// module id = 648
// module chunks = 1